import { Pipe, PipeTransform, inject } from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({
    name: 'zahPrestatieUur',
    standalone: false
})
export class PrestatieUurPipe implements PipeTransform {
  private datePipe = inject(DatePipe);

  transform(prestatieDatum: Date): string {
    return this.datePipe.transform(prestatieDatum, 'HH:mm');
  }
}
